/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useFormContext, UseFormHook } from '@jalik/react-form'
import { useIntl } from 'react-intl'
import FormButton from './FormButton'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { ButtonProps } from '@mantine/core'

function getColor (form: UseFormHook<any, any, any>, defaultColor?: string): string | undefined {
  if (form.submitted) {
    return 'green'
  }
  if (form.submitError) {
    return 'red'
  }
  return defaultColor
}

export type FormSubmitButtonProps = ButtonProps & {
  label?: string,
  icon?: IconProp,
}

function FormSubmitButton (props: FormSubmitButtonProps) {
  const {
    color,
    icon,
    label,
    ...others
  } = props

  const intl = useIntl()
  const form = useFormContext()
  const { submitting } = form
  return (
    // @ts-ignore
    <FormButton
      variant="filled"
      leftSection={icon != null
        ? <FontAwesomeIcon
          fixedWidth
          icon={icon}
        />
        : null}
      {...others}
      color={getColor(form, color)}
      loading={submitting}
      type="submit"
    >
      {!submitting && form.submitError != null
        ? intl.formatMessage({
          id: 'retry',
          defaultMessage: 'Réessayer'
        })
        : label}
    </FormButton>
  )
}

export default FormSubmitButton
